<h3 mat-dialog-title><i class="{{ data.icon }}"></i> {{ data.title }}</h3>
<div mat-dialog-actions>
  <button
    class="btn btn-ok"
    mat-button
    (click)="ok()"
    [mat-dialog-close]="data"
    cdkFocusInitial
  >
    {{ data.ok }}
  </button>
  <button
    class="btn btn-cancel"
    mat-button
    (click)="cancel()"
    [mat-dialog-close]="data"
  >
    {{ data.cancel }}
  </button>
</div>
<div class="clearfix"></div>
